import { render } from "./Setting.vue?vue&type=template&id=09eaaa81&scoped=true&bindings={\"save\":\"setup\",\"handleLogout\":\"setup\"}"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"

import "./Setting.vue?vue&type=style&index=0&id=09eaaa81&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-09eaaa81"

export default script